import { configureStore } from '@reduxjs/toolkit';
import languageReducer from '../features/language/languageSlice';
import uploadsReducer from '../features/uploads/uploadsSlice';
import accountReducer from '../features/account/accountSlice';
import preferencesReducer from '../features/preferences/preferencesSlice';
import dashboardsReducer from '../features/dashboards/dashboardsSlice';
import ingestSlice from '../features/ingest/ingestSlice';
import alertsSlice from '../features/alerts/alertsSlice';
import mappingAdminReducer from '../features/mappingAdmin/mappingAdminSlice';
import mappingAuditReducer from '../features/mappingAudit/mappingAuditSlice';
import uploadsMiddleware from '../features/uploads/uploadsMiddleware';
import accountMiddleware from '../features/account/accountMiddleware';
import preferencesMiddleware from '../features/preferences/preferencesMiddleware';
import dashboardsMiddleware from '../features/dashboards/dashboardsMiddleware';

export default configureStore({
  reducer: {
    language: languageReducer,
    uploads: uploadsReducer,
    account: accountReducer,
    preferences: preferencesReducer,
    dashboards: dashboardsReducer,
    ingest: ingestSlice.reducer,
    alerts: alertsSlice.reducer,
    mappingAdmin: mappingAdminReducer,
    mappingAudit: mappingAuditReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      uploadsMiddleware,
      accountMiddleware,
      preferencesMiddleware,
      dashboardsMiddleware,
    ]),
});
